import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@backstage/ui';
import { EntityInfoCard } from '@backstage/plugin-catalog-react';
import { useGithubSignedIn } from './useGithubSignedIn';

/*
 * One GitHub prompt per Repository page instead of four.
 *
 * Each code-insights card (Readme, Languages, Releases, Contributors) wraps its
 * body in the vendor's `GitHubAuthorizationWrapper`, which renders its own
 * `InfoCard` with a blue-outline MUI "Sign in" button when the user has not
 * granted the GitHub scope. Signed out, a Repository overview is therefore four
 * copies of the same sentence and button — and the Readme's copy nests a second
 * card ("Markdown Card") inside the first.
 *
 * `GithubSignInGate` hides those cards until the scope is granted, and this card
 * asks for it once, in the portal's card grammar with a BUI button.
 */
const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 14,
  },
  copy: {
    fontSize: 12.5,
    lineHeight: 1.5,
    color: 'var(--bui-fg-secondary)',
    minWidth: 180,
    flex: 1,
  },
});

export function GithubSignInCard() {
  const classes = useStyles();
  const { isSignedIn, signIn } = useGithubSignedIn();

  if (isSignedIn) {
    return null;
  }

  return (
    <EntityInfoCard title="GitHub">
      <div className={classes.root}>
        <span className={classes.copy}>
          Sign in to GitHub to load the readme, languages, releases and
          contributors for this repository.
        </span>
        <Button onClick={signIn}>Sign in</Button>
      </div>
    </EntityInfoCard>
  );
}
